module.exports = __webpack_public_path__ + "static/img/top-img5.6c0aed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/top-img5.png
// module id = kYf7
// module chunks = 0